let about = {
        title: 'About Me',
        first_paragraph: 'In recent years, I have designed and implemented entire ecossystems for companies. I have worked directly or indirectly with Delfos, Techify, Redes Brasil, and Complem.',
        second_paragraph: 'Currently, I am serving on the Delfos team, where I develop automation, AI and data solutions.',
        third_paragraph: 'I maintain a strong commitment to technical rigor, continuous learning, and delivering measurable results.'
}

export default about;

